<template>
    <v-container>
        <v-row>
            <!-- Page Header -->
            <v-col
                class="col col-md-12"
                style="padding: 12px 0px;"
            >
                <v-toolbar flat>
                    <div class="d-flex justify-space-between align-center">
                        <v-btn
                            icon
                            class="btn-back"
                            @click="backMapLayers()"
                        >
                            <v-icon class="material-icons-outlined">
                                chevron_left
                            </v-icon>
                        </v-btn>
                        <v-toolbar-title
                            class="pl-3"
                        >
                            <span class="title">
                                Upload Map Layer 
                            </span>
                        </v-toolbar-title>
                    </div>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-divider class="my-3" />
        <v-card flat>
            <v-card-text class="border border-4 mb-2">
                <v-container>
                    <v-row>
                        <v-col>
                            Upload an ESRI Shape file using this page.  Supported shape file types are Point, Line and Polygon (ESRI Shape types 1, 3 and 5 respectively).<br><br>
                            Coordinates should be in Latitude / Longitude decimal degrees using the NAD83 datum (EPSG:4269) coordinate reference system (CRS).<br><br>
                            <em>Points and Lines will be converted to Polygons by buffering Points by 15 feet and buffering Lines by 5 feet.</em><br><br>
                        </v-col>
                    </v-row>
                    <v-row class="my-6 title">
                        Map Layer Information
                    </v-row>
                    <v-row class="subtitle">
                        {{ mapLayer.name }}
                    </v-row>
                    <v-row>{{ mapLayer.description }}</v-row>
                    <v-row class="my-6 title">
                        Upload Files
                    </v-row>
                    <v-row>File names must all have the same base name.  Maximum Upload Size id 40 MB.</v-row>
                    <v-row v-if="!uploading">
                        <v-col>               
                            <v-file-input
                                v-model="files.file_shp"
                                label=".shp File"
                                prepend-icon="attach_file"
                                color="primary"
                                accept=".shp"
                                outlined
                                dense                   
                            />
                        </v-col>            
                    </v-row>
                    <v-row v-if="!uploading">
                        <v-col>
                            <v-file-input
                                v-model="files.file_shx"
                                label=".shx File"
                                prepend-icon="attach_file"
                                color="primary"
                                accept=".shx"                   
                                outlined
                                dense                    
                            />
                        </v-col>            
                    </v-row>
                    <v-row v-if="!uploading">
                        <v-col>
                            <v-file-input
                                v-model="files.file_dbf"
                                label=".dbf File"
                                prepend-icon="attach_file"
                                color="primary"
                                accept=".dbf"                    
                                outlined
                                dense                    
                            />
                        </v-col>            
                    </v-row>
                    <v-row v-if="!uploading">           
                        <v-col>
                            <v-file-input
                                v-model="files.file_prj"
                                label=" .prj File"
                                prepend-icon="attach_file"
                                color="primary"
                                accept=".prj"
                                outlined
                                dense                    
                            />
                        </v-col>            
                    </v-row>
                    <v-row v-if="uploading">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            :size="100"
                            :width="7"
                        />           
                    </v-row>
                    <v-row v-if="uploading">
                        <v-col class="mx-2">
                            Uploading Map Layers 
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>       
            <v-card-actions>
                <v-spacer />
                <div
                    :class="this.$vuetify.breakpoint.smAndUp ? 'bottomNav' : 'bottomNav-mobile'"                    
                    class="d-flex mt-2"
                >
                    <v-btn
                        depressed
                        @click="backMapLayers()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        depressed
                        color="primary"
                        @click="uploadFiles()"
                    >
                        Upload                
                    </v-btn>            
                </div>
            </v-card-actions>       
        </v-card>
    </v-container>
</template>

<script>
import webtmsBackend from '../../../services/webtmsBackend';
import { guidEqual } from '@/utils/guid.js';

export default {
    name: 'UploadMapLayer',
   
    data() {
        return {
            layerId: null,
            uploading: false,
            mapLayer:{
                layer_id: '',
                name:'',
                description:'',
                style:{
                    color:'',
                    show:false     
                }
            },
            file_shp: null,
            file_shx: null,
            file_dbf: null,
            file_prj: null,
            files:{ 
                file_shp: null,
                file_shx: null,
                file_dbf: null,
                file_prj: null,
            },                        
        };
    },
    created() {
        //
    },
    mounted() {
        //
        this.layerId = this.$route.params.id;
        this.getLayerInfo();               
    },
    methods: {
        //
        backMapLayers() {
            this.$router.push({ path: '/settings/map-layers' });
        },
        async getLayerInfo() {
            this.mapLayer = this.$store.getters.companyLayers.find(layer => guidEqual(layer.layer_id, this.layerId));
        },
        async uploadFiles(){
            this.uploading = true;
            // Add the files to the form data
            let formData = new FormData();
          
            formData.append('file_shp', this.files.file_shp);
            formData.append('file_shx', this.files.file_shx);
            formData.append('file_dbf', this.files.file_dbf);
            formData.append('file_prj', this.files.file_prj);

            // Add the layer id to the form data
            formData.append('name', this.mapLayer.name);
            formData.append('description', this.mapLayer.description);           

            if(this.file_size > 4097152){
                this.$store.dispatch('setSnackbar', {
                    text: 'File size must be less than 40 MB',
                    color: 'error'
                });
                return;
            }
            let response = await  webtmsBackend.uploadMapLayer(formData);                                    
            if(response.err){
                this.uploading = false;               
                this.$store.dispatch('setSnackbar', {
                    text: response.err,
                    color: 'error'
                });               
            } else{
                this.$store.dispatch('getCompanyLayers');
                this.$router.push({ path: '/settings/map-layers' });
                this.$store.dispatch('setSnackbar', {
                    text: 'Map layer added successfully!',
                    color: 'success'
                });               
                
            }
        },             
    }
};
</script>

<style>
.v-progress-circular {
  margin: 1rem;
}
.v-file-input{
      max-width: 400px;
}
p {
    color: rgb(180, 108, 199);
}
.bottomNav {
  position: fixed;
  left: 0;
  right: 75%;
  bottom: 0px;
  height: 80px;
  display: flex;
  background: #ffffff;
  justify-content: center;  
}
.bottomNav-mobile {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 80px;
  display: flex;
  background: #ffffff;
  justify-content: center;
  padding: 16px 16px;
  border-top: 1px solid #dad6d6;

}
.v-btn.mobile-btn{
  width: 134px;
  height: 48px;
  padding: 16px;
}
</style>